<template>
  <!-- <wx-open-launch-weapp
    id="launch-btn"
    username="gh_4f5f29e7b3ab"
    :appid="appid"
    :path="path"
    :class="className + ' wx-open-enter'"
    v-if="isWechatEnv"
  >
  </wx-open-launch-weapp> -->
  <div class="wx-open-enter" @click="hanldeOpenSqWechat"></div>
</template>

<script>
import { getSqWechatLink } from "@/assets/js/api/author";

const appidConfig = {
  sq: "wx550e53f8b403dd49",
};

export default {
  name: "openWechat",
  props: {
    isWechatEnvProp: {
      default: undefined,
    },
    className: {
      default: "",
    },
    platform: {
      default: "",
    },
    path: {
      default: "",
    },
    platform: {
      default: "sq",
    },
    handleLoading: {
      default: (data) => undefined,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    isWechatEnv() {
      if (this.isWechatEnvProp !== undefined) {
        return this.isWechatEnvProp;
      }
      const userAgent = navigator.userAgent.toLocaleLowerCase();
      return /micromessenger/.test(userAgent);
    },
    text() {
      return {
        id: this.number,
        val: this.newsData[this.number].title,
        url: this.newsData[this.number].url,
      };
    },
    appid() {
      return this.platform ? appidConfig[this.platform] || "" : "";
    },
  },
  methods: {
    hanldeOpenSqWechat() {
      if (!this.path) return;

      if (this.isWechatEnv) {
        window.location.href = `/m/wechat/${this.platform}?path=${this.path}`;
        return;
      }

      if (this.loading) return;

      this.loading = true;
      this.handleLoading && this.handleLoading(true);
      getSqWechatLink({
        path: this.path,
      })
        .then((res) => {
          if (res && res.data && res.data.data) {
            window.location.href = res.data.data;
          }
          this.loading = false;
          this.handleLoading && this.handleLoading(false);
        })
        .catch((err) => {
          this.loading = false;
          this.handleLoading && this.handleLoading(false);
        });
    },
  },
};
</script>

<style lang="css" scoped>
.wx-open-enter {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// openWechat.vue?6f5a2c62